export const permissionActionButtonClass =
  'flex-1 !h-[42px] !px-3 !text-sm justify-center gap-2';

export const permissionSortButtonClass =
  'flex size-[42px] shrink-0 items-center justify-center rounded-lg border border-[var(--theme-secondary-ink)] text-[var(--theme-secondary-ink)]';

export const permissionHeaderIconClass =
  'flex size-6 shrink-0 items-center justify-center overflow-hidden rounded bg-[var(--theme-secondary)] text-white';

export const permissionFooterButtonClass =
  'flex flex-1 items-center justify-center gap-2 rounded-lg bg-[var(--theme-secondary)] px-3 text-sm font-medium leading-tight text-white disabled:opacity-50 h-[42px]';

export const configureAddButtonClass =
  'flex size-10.5 shrink-0 items-center justify-center rounded-lg bg-[var(--theme-secondary)] text-white';

export const configureSectionIconClass =
  'flex size-6 shrink-0 items-center justify-center rounded-[4px] bg-gray-03 text-white';

export const configureAddIconFrameClass =
  'flex size-5 items-center justify-center rounded border border-white';
